import styled from 'styled-components'
import { breakpoint } from 'utils/consts/breakpoints'
import { FC, ReactNode } from 'react'
import {
  Title,
  EmptyContent,
  LoaderWrapper,
} from 'components/Pages/Review/Common/Form/Content/Product/RecognitionModal/Form/LabelsImages/UploadItem/_styles'

const ErrorWrapper = styled.div``

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`
const ItemsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 8px;

  ${Title} {
    font: var(--typography-14-16-semibold);
    color: var(--color-sw-60);
    margin-bottom: 8px;
  }

  ${EmptyContent} {
    margin-top: -24px;
  }

  ${LoaderWrapper} {
    margin-top: -24px;
  }

  @media screen and ${breakpoint.s} {
    display: grid;
    grid-template-columns: repeat(3, calc((100% - 16px) / 3));
    grid-gap: 8px;
  }
`
interface ImagesContainerProps {
  imagesNode: ReactNode
  descriptionNode: ReactNode
  errorNode?: ReactNode
}

const ImagesContainer: FC<ImagesContainerProps> = ({
  imagesNode,
  descriptionNode,
  errorNode,
}) => {
  return (
    <Wrapper>
      <ItemsWrapper>{imagesNode}</ItemsWrapper>
      {errorNode && <ErrorWrapper>{errorNode}</ErrorWrapper>}
      {descriptionNode}
    </Wrapper>
  )
}

export default ImagesContainer
